(function (scope, factory) {
  'use strict';
  var api = factory();
  scope.RwadyStorefrontCart = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var ENDPOINT = '/api/2026-07/graphql.json';
  var CART_CREATE = [
    'mutation RwadyCartCreate($input: CartInput, $language: LanguageCode!) @inContext(language: $language) {',
    '  cartCreate(input: $input) {',
    '    cart { id checkoutUrl totalQuantity attributes { key value } buyerIdentity { phone email countryCode } delivery { addresses(selected: true) { selected oneTimeUse address { ... on CartDeliveryAddress { firstName lastName address1 address2 city countryCode phone } } } } }',
    '    userErrors { field message code }',
    '    warnings { message code target }',
    '  }',
    '}'
  ].join('\n');
  var BUYER_IDENTITY_UPDATE = [
    'mutation RwadyBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!, $language: LanguageCode!) @inContext(language: $language) {',
    '  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {',
    '    cart { id checkoutUrl buyerIdentity { phone email countryCode } }',
    '    userErrors { field message code }',
    '    warnings { message code target }',
    '  }',
    '}'
  ].join('\n');
  var CART_VERIFY = [
    'query RwadyCartVerify($cartId: ID!, $language: LanguageCode!) @inContext(language: $language) {',
    '  cart(id: $cartId) {',
    '    id checkoutUrl totalQuantity discountCodes { code applicable } cost { totalAmount { amount currencyCode } subtotalAmount { amount currencyCode } } attributes { key value }',
    '    buyerIdentity { phone email countryCode }',
    '    delivery { addresses(selected: true) { selected oneTimeUse address { ... on CartDeliveryAddress { firstName lastName address1 address2 city countryCode phone } } } }',
    '  }',
    '}'
  ].join('\n');

  function clean(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function normalizeDigits(value) {
    var arabic = '٠١٢٣٤٥٦٧٨٩';
    var persian = '۰۱۲۳۴۵۶۷۸۹';
    return String(value || '').replace(/[٠-٩]/g, function (digit) {
      return String(arabic.indexOf(digit));
    }).replace(/[۰-۹]/g, function (digit) {
      return String(persian.indexOf(digit));
    });
  }

  function normalizeIraqiPhone(value) {
    var digits = normalizeDigits(value).replace(/\D/g, '');
    if (digits.indexOf('00964') === 0) digits = digits.slice(2);
    if (digits.indexOf('964') === 0) return /^9647\d{9}$/.test(digits) ? '+' + digits : '';
    if (/^07\d{9}$/.test(digits)) return '+964' + digits.slice(1);
    return '';
  }

  function validEmail(value) {
    var email = clean(value).toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
  }

  function languageCode(value) {
    var locale = clean(value).toLowerCase().replace('_', '-');
    return locale === 'en' || locale.indexOf('en-') === 0 ? 'EN' : 'AR';
  }

  function storefrontLanguage(value) {
    var shopify = typeof globalThis !== 'undefined' && globalThis.Shopify;
    var html = typeof document !== 'undefined' && document.documentElement;
    return languageCode(value || shopify && shopify.locale || html && html.lang);
  }

  function splitFullName(value) {
    var parts = clean(value).split(' ').filter(Boolean);
    if (!parts.length) return { firstName: '', lastName: '' };
    if (parts.length === 1) return { firstName: parts[0], lastName: parts[0] };
    return { firstName: parts.slice(0, -1).join(' '), lastName: parts[parts.length - 1] };
  }

  function gid(type, value) {
    var id = clean(value);
    if (!id) return '';
    return id.indexOf('gid://shopify/') === 0 ? id : 'gid://shopify/' + type + '/' + id;
  }

  function attributeValue(value) {
    if (value === null || value === undefined) return '';
    return typeof value === 'string' ? value : JSON.stringify(value);
  }

  function attributesFromObject(attributes) {
    return Object.keys(attributes || {}).filter(function (key) {
      return attributes[key] !== null && attributes[key] !== undefined && attributes[key] !== '';
    }).map(function (key) {
      return { key: String(key), value: attributeValue(attributes[key]) };
    });
  }

  var INSTALLMENT_PRICING_KEYS = [
    'pre_checkout_installment_base_amount_iqd',
    'pre_checkout_installment_financing_fee_iqd',
    'pre_checkout_installment_total_iqd',
    'pre_checkout_installment_count',
    'pre_checkout_installment_monthly_amount_iqd',
    'pre_checkout_installment_shipping_iqd'
  ];
  var ONLINE_PRICING_KEYS = [
    'pre_checkout_online_card_type',
    'pre_checkout_online_fee_rate_bps',
    'pre_checkout_online_fee_base_amount_iqd',
    'pre_checkout_online_fee_amount_iqd',
    'pre_checkout_online_payable_amount_iqd',
    'pre_checkout_online_shipping_iqd'
  ];
  var NUMERIC_ATTRIBUTE_KEYS = INSTALLMENT_PRICING_KEYS.concat([
    'pre_checkout_pricing_schema_version',
    'pre_checkout_online_fee_rate_bps',
    'pre_checkout_online_fee_base_amount_iqd',
    'pre_checkout_online_fee_amount_iqd',
    'pre_checkout_online_payable_amount_iqd',
    'pre_checkout_online_shipping_iqd'
  ]);

  function numberOrNull(value) {
    if (value === '' || value === null || value === undefined) return null;
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
  }

  function iqdFromCents(value) {
    var cents = numberOrNull(value);
    return cents === null ? null : String(Math.round(cents / 100));
  }

  function iqd(value) {
    var amount = numberOrNull(value);
    return amount === null ? null : String(Math.round(amount));
  }

  function paymentPricingAttributes(snapshot) {
    var values = snapshot || {};
    var result = {
      pre_checkout_pricing_schema_version: '1',
      pre_checkout_pricing_currency: 'IQD'
    };
    if (values.method !== 'installment' && values.method !== 'online') return result;
    var baseCents = numberOrNull(values.baseCents);
    var baseIqd = iqdFromCents(values.baseCents);
    var shippingIqd = iqd(values.shippingIqd);
    if (baseCents === null || baseIqd === null || shippingIqd === null) return null;

    if (values.method === 'installment') {
      var totalCents = numberOrNull(values.installmentTotalCents);
      if (totalCents === null || totalCents < baseCents) return null;
      var totalIqd = iqdFromCents(totalCents);
      var financingFeeIqd = iqdFromCents(totalCents - baseCents);
      var monthlyIqd = iqdFromCents(totalCents / 10);
      if (totalIqd === null || financingFeeIqd === null || monthlyIqd === null) return null;
      result.pre_checkout_installment_base_amount_iqd = baseIqd;
      result.pre_checkout_installment_financing_fee_iqd = financingFeeIqd;
      result.pre_checkout_installment_total_iqd = totalIqd;
      result.pre_checkout_installment_count = '10';
      result.pre_checkout_installment_monthly_amount_iqd = monthlyIqd;
      result.pre_checkout_installment_shipping_iqd = shippingIqd;
      return result;
    }

    var card = values.cardDetail === 'local_card'
      ? { type: 'local', rate: numberOrNull(values.localCardRate), bps: '100' }
      : values.cardDetail === 'international_card'
        ? { type: 'international', rate: numberOrNull(values.internationalCardRate), bps: '275' }
        : null;
    if (!card || card.rate === null) return null;
    var feeBaseCents = baseCents + Number(shippingIqd) * 100;
    var feeBaseIqd = iqdFromCents(feeBaseCents);
    var feeCents = Math.round(feeBaseCents * card.rate);
    var feeIqd = iqdFromCents(feeCents);
    var payableIqd = iqdFromCents(feeBaseCents + feeCents);
    if (feeBaseIqd === null || feeIqd === null || payableIqd === null) return null;
    result.pre_checkout_online_card_type = card.type;
    result.pre_checkout_online_fee_rate_bps = card.bps;
    result.pre_checkout_online_fee_base_amount_iqd = feeBaseIqd;
    result.pre_checkout_online_fee_amount_iqd = feeIqd;
    result.pre_checkout_online_payable_amount_iqd = payableIqd;
    result.pre_checkout_online_shipping_iqd = shippingIqd;
    return result;
  }

  function normalizedAttributeValue(key, value) {
    var normalized = clean(value);
    if (NUMERIC_ATTRIBUTE_KEYS.indexOf(key) === -1) return normalized;
    var number = Number(normalizeDigits(normalized).replace(/,/g, ''));
    return Number.isFinite(number) && number >= 0 ? String(number) : normalized;
  }

  function hasExpectedAttributes(actual, expected) {
    var values = Object.create(null);
    (Array.isArray(actual) ? actual : []).forEach(function (attribute) {
      if (!attribute || attribute.key === undefined) return;
      var key = clean(attribute.key);
      if (key) values[key] = normalizedAttributeValue(key, attribute.value);
    });
    return Object.keys(expected || {}).filter(function (key) {
      return expected[key] !== null && expected[key] !== undefined && clean(expected[key]) !== '';
    }).every(function (key) {
      var normalizedKey = clean(key);
      return values[normalizedKey] === normalizedAttributeValue(normalizedKey, expected[key]);
    });
  }

  function lineAttributes(properties) {
    return Object.keys(properties || {}).filter(function (key) {
      return properties[key] !== null && properties[key] !== undefined && properties[key] !== '';
    }).map(function (key) {
      return { key: String(key), value: attributeValue(properties[key]) };
    });
  }

  function cartLines(cart) {
    return (cart && Array.isArray(cart.items) ? cart.items : []).map(function (item) {
      var line = {
        merchandiseId: gid('ProductVariant', item.variant_id || item.id),
        quantity: Math.max(1, Number(item.quantity) || 1)
      };
      var attributes = lineAttributes(item.properties);
      if (attributes.length) line.attributes = attributes;
      var sellingPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
      if (sellingPlanId) line.sellingPlanId = gid('SellingPlan', sellingPlanId);
      return line;
    }).filter(function (line) { return Boolean(line.merchandiseId); });
  }

  function cartInput(cart, customer) {
    var phone = normalizeIraqiPhone(customer && customer.phone);
    var deliveryPhone = normalizeIraqiPhone(customer && customer.deliveryPhone) || phone;
    var email = validEmail(customer && customer.email);
    var buyerIdentity = { countryCode: 'IQ' };
    if (email) buyerIdentity.email = email;
    if (phone) buyerIdentity.phone = phone;

    var address = customer && customer.address || {};
    var deliveryAddress = {
      firstName: clean(address.firstName),
      lastName: clean(address.lastName),
      address1: clean(address.address1),
      city: clean(address.city),
      countryCode: 'IQ'
    };
    if (clean(address.address2)) deliveryAddress.address2 = clean(address.address2);
    if (deliveryPhone) deliveryAddress.phone = deliveryPhone;
    var input = {
      lines: cartLines(cart),
      attributes: attributesFromObject(cart && cart.attributes),
      buyerIdentity: buyerIdentity,
      delivery: {
        addresses: [{
          selected: true,
          oneTimeUse: true,
          validationStrategy: 'COUNTRY_CODE_ONLY',
          address: { deliveryAddress: deliveryAddress }
        }]
      }
    };
    if (cart && clean(cart.note)) input.note = clean(cart.note);
    return input;
  }

  function fieldNames(field) {
    return (Array.isArray(field) ? field : []).filter(function (part) {
      return typeof part === 'string' && !/^\d+$/.test(part);
    });
  }

  function diagnosticEntry(entry) {
    return {
      code: clean(entry && entry.code),
      fields: fieldNames(entry && (entry.field || entry.target))
    };
  }

  function graphqlDiagnostic(entry) {
    return {
      code: clean(entry && entry.extensions && entry.extensions.code),
      fields: fieldNames(entry && entry.path)
    };
  }

  function responseHeader(response, name) {
    return response && response.headers && typeof response.headers.get === 'function'
      ? clean(response.headers.get(name))
      : '';
  }

  function safeError(code, details) {
    var error = new Error(code);
    error.code = code;
    error.diagnostics = details || null;
    return error;
  }

  function contextLanguage(payload) {
    return clean(payload && payload.extensions && payload.extensions.context && payload.extensions.context.language).toUpperCase();
  }

  async function storefrontRequest(fetchImpl, endpoint, query, variables, language, stage) {
    var response;
    try {
      response = await fetchImpl(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: query, variables: Object.assign({}, variables, { language: language }) })
      });
    } catch (failure) {
      throw safeError('STOREFRONT_FETCH_FAILED', {
        status: 0,
        stage: stage,
        code: 'STOREFRONT_FETCH_FAILED',
        errorName: clean(failure && failure.name) || 'Error',
        failureType: failure instanceof TypeError ? 'network' : 'fetch',
        graphQLErrors: [],
        userErrors: [],
        warnings: []
      });
    }
    var jsonValid = true;
    var payload = await response.json().catch(function () { jsonValid = false; return {}; });
    if (!response.ok || payload.errors && payload.errors.length) {
      throw safeError('STOREFRONT_REQUEST_FAILED', {
        status: Number(response.status) || 0,
        contentType: responseHeader(response, 'content-type'),
        requestId: responseHeader(response, 'x-request-id'),
        jsonValid: jsonValid,
        stage: stage,
        code: 'STOREFRONT_REQUEST_FAILED',
        graphQLErrors: (payload.errors || []).map(graphqlDiagnostic),
        userErrors: [],
        warnings: []
      });
    }
    if (contextLanguage(payload) !== language) {
      throw safeError('STOREFRONT_LANGUAGE_MISMATCH', {
        status: Number(response.status) || 0,
        stage: stage,
        code: 'STOREFRONT_LANGUAGE_MISMATCH',
        userErrors: [],
        warnings: []
      });
    }
    return { response: response, payload: payload };
  }

  function assertCartPayload(result, response, stage) {
    if (!result || result.userErrors && result.userErrors.length) {
      throw safeError('STOREFRONT_CART_REJECTED', {
        status: Number(response.status) || 0,
        stage: stage,
        code: 'STOREFRONT_CART_REJECTED',
        userErrors: (result && result.userErrors || []).map(diagnosticEntry),
        warnings: (result && result.warnings || []).map(diagnosticEntry)
      });
    }
    return result.cart;
  }

  async function createCheckoutCart(options) {
    var settings = options || {};
    var fetchImpl = settings.fetchImpl || (typeof fetch === 'function' ? fetch.bind(globalThis) : null);
    if (!fetchImpl) throw safeError('STOREFRONT_FETCH_UNAVAILABLE');
    var input = cartInput(settings.cart, settings.customer);
    if (settings.loyalty) input.discountCodes = [settings.loyalty.code];
    var language = storefrontLanguage(settings.language);
    var endpoint = clean(settings.endpoint) || ENDPOINT;
    if (!input.lines.length) throw safeError('STOREFRONT_CART_EMPTY');
    if (!input.delivery.addresses[0].address.deliveryAddress.address1) throw safeError('STOREFRONT_ADDRESS_REQUIRED');
    if (!input.buyerIdentity.phone || !/^\+[1-9]\d{7,14}$/.test(input.buyerIdentity.phone)) {
      throw safeError('STOREFRONT_PHONE_REQUIRED');
    }

    var created = await storefrontRequest(fetchImpl, endpoint, CART_CREATE, { input: input }, language, 'cartCreate');
    var createdCart = assertCartPayload(created.payload.data && created.payload.data.cartCreate, created.response, 'cartCreate');
    if (!createdCart || !createdCart.id) throw safeError('STOREFRONT_CHECKOUT_UNAVAILABLE');
    var originalCartId = createdCart.id;

    var identity = await storefrontRequest(fetchImpl, endpoint, BUYER_IDENTITY_UPDATE, {
      cartId: originalCartId,
      buyerIdentity: input.buyerIdentity
    }, language, 'cartBuyerIdentityUpdate');
    assertCartPayload(identity.payload.data && identity.payload.data.cartBuyerIdentityUpdate, identity.response, 'cartBuyerIdentityUpdate');

    var verified = await storefrontRequest(fetchImpl, endpoint, CART_VERIFY, {
      cartId: originalCartId
    }, language, 'cartVerify');
    var resultCart = verified.payload.data && verified.payload.data.cart;
    if (!resultCart || !resultCart.checkoutUrl) throw safeError('STOREFRONT_CHECKOUT_UNAVAILABLE');
    if (settings.loyalty && !(resultCart.discountCodes || []).some(function (discount) {
      return discount.code.toUpperCase() === settings.loyalty.code.toUpperCase() && discount.applicable === true;
    })) throw safeError('LOYALTY_DISCOUNT_NOT_APPLIED');
    var expectedAttributes = Object.create(null);
    attributesFromObject(settings.cart && settings.cart.attributes).forEach(function (attribute) {
      expectedAttributes[attribute.key] = attribute.value;
    });
    if (!hasExpectedAttributes(resultCart.attributes, expectedAttributes)) {
      throw safeError('STOREFRONT_ATTRIBUTES_MISMATCH');
    }
    var expectedPhone = input.buyerIdentity.phone;
    var expectedDeliveryPhone = input.delivery.addresses[0].address.deliveryAddress.phone;
    var selectedAddress = resultCart.delivery && resultCart.delivery.addresses && resultCart.delivery.addresses[0];
    var verifiedDelivery = selectedAddress && selectedAddress.address;
    var buyerPhone = normalizeIraqiPhone(resultCart.buyerIdentity && resultCart.buyerIdentity.phone);
    var deliveryPhone = normalizeIraqiPhone(verifiedDelivery && verifiedDelivery.phone);
    if ((expectedPhone && buyerPhone !== expectedPhone) || (expectedDeliveryPhone && deliveryPhone !== expectedDeliveryPhone)) {
      throw safeError('STOREFRONT_CONTACT_MISMATCH', {
        buyerPhonePresent: Boolean(buyerPhone),
        buyerPhoneE164: /^\+[1-9]\d{7,14}$/.test(buyerPhone),
        buyerPhoneMatches: buyerPhone === expectedPhone,
        deliveryPhonePresent: Boolean(verifiedDelivery && verifiedDelivery.phone),
        deliveryPhoneE164: /^\+[1-9]\d{7,14}$/.test(deliveryPhone),
        deliveryPhoneMatches: deliveryPhone === expectedDeliveryPhone
      });
    }
    if (input.buyerIdentity.email && (!resultCart.buyerIdentity || clean(resultCart.buyerIdentity.email).toLowerCase() !== input.buyerIdentity.email)) {
      throw safeError('STOREFRONT_CONTACT_MISMATCH');
    }
    if (!selectedAddress || selectedAddress.selected !== true || selectedAddress.oneTimeUse !== true) {
      throw safeError('STOREFRONT_ADDRESS_MISMATCH');
    }
    var expectedDelivery = input.delivery.addresses[0].address.deliveryAddress;
    if (!verifiedDelivery || ['firstName', 'lastName', 'address1', 'address2', 'city', 'countryCode'].some(function (field) {
      return clean(verifiedDelivery[field]) !== clean(expectedDelivery[field]);
    })) {
      throw safeError('STOREFRONT_ADDRESS_MISMATCH');
    }
    return { checkoutUrl: resultCart.checkoutUrl, language: language, cartId: resultCart.id };
  }

  return {
    ENDPOINT: ENDPOINT,
    normalizeIraqiPhone: normalizeIraqiPhone,
    validEmail: validEmail,
    languageCode: languageCode,
    storefrontLanguage: storefrontLanguage,
    splitFullName: splitFullName,
    cartLines: cartLines,
    cartInput: cartInput,
    INSTALLMENT_PRICING_KEYS: INSTALLMENT_PRICING_KEYS,
    ONLINE_PRICING_KEYS: ONLINE_PRICING_KEYS,
    paymentPricingAttributes: paymentPricingAttributes,
    hasExpectedAttributes: hasExpectedAttributes,
    normalizedAttributeValue: normalizedAttributeValue,
    fieldNames: fieldNames,
    contextLanguage: contextLanguage,
    createCheckoutCart: createCheckoutCart
  };
}));

